import React, { createContext, useContext, useState } from 'react';

const StateContext = createContext();

const initialState = {
    userProfile: false,
    notification: false,
    passwordusuario:false,
    nuevasucursal:false,
    nuevousuarios:false,
    nuevopatron:false,
    nuevoparametro:false,
    nuevonavegador:false,
    nuevoccosto:false,
    nuevoequipo:false,
    nuevocapacidad:false,
    nuevoproyecto:false,
    nuevasolicitud:false,
    nuevaasignacion: false,
    asignaporequipo: false,
    nuevomandante: false,
    nuevodocugeneral: false,
    nuevoImplementa: false,
    nuevoTicket: false,
    nuevoAutoriza: false,
    nuevaCarpeta: false,
    buscaDocumento:false,
    cargarsolicitud:false,
    detalleAcreditacion: false,
    detalleFichaEquipo: false,
  };

  export const ContextProvider = ({ children }) => {
    const [screenSize, setScreenSize] = useState(undefined);
    const [currentColor, setCurrentColor] = useState('#1E4DB7'); // '#03C9D7'
    const [currentMode, setCurrentMode] = useState('Light');
    const [themeSettings, setThemeSettings] = useState(false);
    const [activeMenu, setActiveMenu] = useState(true);
    const [isClicked, setIsClicked] = useState(initialState);
    const [isAuthenticated,setIsAuthenticated] = useState(false);

    const setMode = (e) => {
      setCurrentMode(e.target.value);
      localStorage.setItem('themeMode', e.target.value);
    };
  
    const setColor = (color) => {
      setCurrentColor(color);
      localStorage.setItem('colorMode', color);
    };
  
    const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });
  
    return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      <StateContext.Provider value={{ currentColor, currentMode, activeMenu, 
      screenSize, setScreenSize, handleClick, isClicked, initialState, setIsClicked, setActiveMenu, setCurrentColor, setCurrentMode, setMode, setColor, themeSettings, setThemeSettings, isAuthenticated, setIsAuthenticated }}>
        {children}
      </StateContext.Provider>
    );
  };
  
  export const useStateContext = () => useContext(StateContext);